{
  "familyId": "GELD-KOMMA",
  "questions": [
    {
      "id": "GELD-KOMMA-001",
      "familyId": "GELD-KOMMA",
      "module": "Geld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "multiple_choice",
      "question": "Een boekhandelaar verkoopt een boek voor €12,50. Een klant betaalt met €20. Hoeveel wisselgeld krijgt de klant terug?",
      "options": ["€7,50", "€8,50", "€7,00", "€2,50"],
      "correctAnswer": 0,
      "conceptId": "change_calculation",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wisselgeld berekenen",
            "content": "Wisselgeld = betaald − prijs. Splits het aftrekken: eerst de euro's, dan de centen. €20,00 − €12,00 = €8,00. Dan: €8,00 − €0,50 = €7,50.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Wisselgeld = betaald − prijs. Splits het aftrekken in euro's en centen. Eerst: €20,00 − €12,00 = €8,00. Dan: €8,00 − €0,50 = €7,50. Check: €12,50 + €7,50 = €20,00 ✓.",
        "solutionSteps": [
          "Wisselgeld = betaald − prijs = €20,00 − €12,50",
          "Splits: €20,00 − €12,00 = €8,00",
          "Trek de centen af: €8,00 − €0,50 = €7,50",
          "Check: €12,50 + €7,50 = €20,00 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €20,00 − €12,50 = €7,50 wisselgeld.",
          "1": "Je dacht waarschijnlijk dat €20 − €12 = €8 het hele antwoord is. Maar je moet ook de 50 cent aftrekken: €8,00 − €0,50 = €7,50. Onthoud: trek altijd eerst de euro's af, dan de centen.",
          "2": "Je dacht waarschijnlijk dat je de centen kunt overslaan. Maar €20,00 − €12,50 is niet €7,00 — je vergeet de 50 cent. Onthoud: reken de centen altijd mee bij wisselgeld.",
          "3": "Je dacht waarschijnlijk dat het verschil €2,50 is. Maar €20,00 − €12,50 = €7,50. Onthoud: controleer altijd met optellen: €12,50 + €7,50 = €20,00 ✓."
        }
      }
    },
    {
      "id": "GELD-KOMMA-002",
      "familyId": "GELD-KOMMA",
      "module": "Geld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "multiple_choice",
      "question": "Een kantoormedewerker bestelt 3 schriften van €2,75 per stuk. Hoeveel betaalt zij in totaal?",
      "options": ["€8,25", "€8,75", "€5,75", "€9,25"],
      "correctAnswer": 0,
      "conceptId": "money_multiplication",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "stimulusAids": [{"type": "money", "data": {"amount": 275, "label": "Prijs per schrift: €2,75"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vermenigvuldigen met geldbedragen",
            "content": "Splits de vermenigvuldiging: 3 × €2,00 = €6,00 en 3 × €0,75 = €2,25. Tel op: €6,00 + €2,25 = €8,25.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Splits de vermenigvuldiging in euro's en centen apart. Eerst: 3 × €2,00 = €6,00. Dan: 3 × €0,75 = €2,25. Tel op: €6,00 + €2,25 = €8,25.",
        "solutionSteps": [
          "Splits: 3 × €2,75 = 3 × €2,00 + 3 × €0,75",
          "Euro's: 3 × €2,00 = €6,00",
          "Centen: 3 × €0,75 = €2,25 (want 3 × 75 = 225 cent)",
          "Tel op: €6,00 + €2,25 = €8,25"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 × €2,75 = €8,25.",
          "1": "Je dacht waarschijnlijk dat 3 × 75 cent = 275 cent = €2,75. Maar 3 × 75 = 225 cent = €2,25. Onthoud: reken de centen apart uit en schrijf het als euro's.",
          "2": "Je dacht waarschijnlijk dat je maar 2 schriften hoefde te rekenen. Maar er staan 3 schriften: 3 × €2,75 = €8,25. Onthoud: lees goed hoeveel stuks er gevraagd worden.",
          "3": "Je dacht waarschijnlijk dat je €2,75 naar €3,00 moest afronden: 3 × €3,00 = €9,00. Maar de prijs is €2,75, niet €3,00. Onthoud: reken altijd met het exacte bedrag, niet met een afronding."
        }
      }
    },
    {
      "id": "GELD-KOMMA-003",
      "familyId": "GELD-KOMMA",
      "module": "Geld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "multiple_choice",
      "question": "Een leerling koopt een pen van €1,35 en een schrift van €2,80 bij de schoolwinkel. Hoeveel kosten ze samen?",
      "options": ["€4,15", "€4,25", "€3,15", "€4,05"],
      "correctAnswer": 0,
      "conceptId": "money_addition_carry",
      "variantIndex": 3,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.72,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Optellen met overdracht",
            "content": "Tel de centen apart op: 35 + 80 = 115 cent. Dat is meer dan 100, dus je krijgt een extra euro: 115 cent = €1,15. Euro's: €1 + €2 + €1 (extra) = €4. Totaal: €4,15.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Tel de centen apart op en let op of je boven de 100 cent komt. Centen: 35 + 80 = 115 cent = €1,15 (dat is een extra euro!). Euro's: €1 + €2 + €1 = €4. Totaal: €4,15.",
        "solutionSteps": [
          "Tel de centen op: 35 + 80 = 115 cent",
          "115 cent = €1,15 (meer dan 100 cent = extra euro)",
          "Tel de euro's op: €1 + €2 = €3, plus de extra €1 = €4",
          "Totaal: €4,00 + €0,15 = €4,15"
        ],
        "distractorExplanations": {
          "0": "Goed! €1,35 + €2,80 = €4,15. De 115 cent levert een extra euro op.",
          "1": "Je dacht waarschijnlijk dat 35 + 80 = 125 cent. Maar 35 + 80 = 115 cent = €1,15. Onthoud: reken de centen zorgvuldig: 30 + 80 = 110, dan + 5 = 115.",
          "2": "Je dacht waarschijnlijk dat de centen geen extra euro opleveren. Maar 35 + 80 = 115 cent — dat is meer dan 100, dus je krijgt een extra euro erbij. Onthoud: boven de 100 cent wordt het een extra euro.",
          "3": "Je dacht waarschijnlijk dat 35 + 80 = 105 cent. Maar 35 + 80 = 115 cent = €1,15. Onthoud: 30 + 80 = 110, plus 5 = 115 cent."
        }
      }
    },
    {
      "id": "GELD-KOMMA-004",
      "familyId": "GELD-KOMMA",
      "module": "Geld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "multiple_choice",
      "question": "Een tuinman heeft een budget van €15,00 voor nieuwe handschoenen. De handschoenen kosten €8,65. Hoeveel houdt hij over?",
      "options": ["€6,35", "€6,45", "€7,35", "€5,35"],
      "correctAnswer": 0,
      "conceptId": "money_subtraction_borrow",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.71,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aftrekken met lenen",
            "content": "Bij €15,00 − €8,65: je hebt 0 centen maar moet 65 aftrekken. 'Leen' een euro: 100 − 65 = 35 cent. Euro's: €14 − €8 = €6. Totaal: €6,35.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Splits het aftrekken. Eerst de euro's: €15 − €8 = €7. Dan de centen: €7,00 − €0,65 = €6,35. Je 'leent' een euro om de centen af te trekken: 100 − 65 = 35 cent. Check: €8,65 + €6,35 = €15,00 ✓.",
        "solutionSteps": [
          "Splits: €15,00 − €8,65",
          "Euro's eerst: €15 − €8 = €7,00",
          "Trek de centen af: €7,00 − €0,65",
          "Leen een euro: 100 − 65 = 35 cent → €6,35",
          "Check: €8,65 + €6,35 = €15,00 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €15,00 − €8,65 = €6,35.",
          "1": "Je dacht waarschijnlijk dat 100 − 65 = 45. Maar 100 − 65 = 35 cent. Onthoud: reken het na: 65 + 35 = 100 ✓.",
          "2": "Je dacht waarschijnlijk dat je de centen niet hoeft af te trekken: €15 − €8 = €7. Maar je moet ook €0,65 aftrekken: €7,00 − €0,65 = €6,35. Onthoud: trek altijd de centen mee af.",
          "3": "Je dacht waarschijnlijk dat €15 − €8 = €5 (een rekenfout bij de euro's). Maar 15 − 8 = 7, en dan nog €0,65 aftrekken: €6,35. Onthoud: controleer met optellen: €8,65 + €6,35 = €15,00 ✓."
        }
      }
    },
    {
      "id": "GELD-KOMMA-005",
      "familyId": "GELD-KOMMA",
      "module": "Geld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "multiple_choice",
      "question": "Een leerling koopt 2 broodjes van €3,45 per stuk bij de bakker. Ze betaalt met €10,00. Hoeveel wisselgeld krijgt ze?",
      "options": ["€3,10", "€3,00", "€6,55", "€2,10"],
      "correctAnswer": 0,
      "conceptId": "money_multi_step",
      "variantIndex": 5,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.72,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meerstaps-berekening",
            "content": "Stap 1: bereken de totale kosten: 2 × €3,45 = €6,90. Stap 2: bereken het wisselgeld: €10,00 − €6,90 = €3,10.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Dit is een tweestapsvraag. Eerst de totale kosten: 2 × €3,45 = €6,90 (2 × €3 = €6, 2 × €0,45 = €0,90). Dan het wisselgeld: €10,00 − €6,90 = €3,10.",
        "solutionSteps": [
          "Bereken de totale kosten: 2 × €3,45",
          "Splits: 2 × €3,00 = €6,00 en 2 × €0,45 = €0,90",
          "Totaal: €6,00 + €0,90 = €6,90",
          "Wisselgeld: €10,00 − €6,90 = €3,10"
        ],
        "distractorExplanations": {
          "0": "Goed! 2 × €3,45 = €6,90, dan €10,00 − €6,90 = €3,10 wisselgeld.",
          "1": "Je dacht waarschijnlijk dat €10,00 − €6,90 = €3,00. Maar 100 − 90 = 10 cent, dus het wisselgeld is €3,10, niet €3,00. Onthoud: reken de centen altijd mee.",
          "2": "Je dacht waarschijnlijk dat €6,55 het wisselgeld is. Maar €6,55 zou kloppen als je maar 1 broodje kocht: €10,00 − €3,45 = €6,55. Je koopt er 2: totaal €6,90. Onthoud: bereken eerst de totale kosten.",
          "3": "Je dacht waarschijnlijk dat 2 × €3,45 = €7,90 (een rekenfout). Maar 2 × €3,45 = €6,90. Onthoud: splits de vermenigvuldiging: 2 × €3 = €6 en 2 × €0,45 = €0,90."
        }
      }
    },
    {
      "id": "GELD-KOMMA-006",
      "familyId": "GELD-KOMMA",
      "module": "Geld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "multiple_choice",
      "question": "Bij de boerderijwinkel kost verse melk €1,25 per liter. Een klant koopt 4 liter. Hoeveel betaalt de klant?",
      "options": ["€5,00", "€5,25", "€4,00", "€4,25"],
      "correctAnswer": 0,
      "conceptId": "money_multiplication_quarters",
      "variantIndex": 6,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.75,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vermenigvuldigen met kwartjes",
            "content": "4 × €1,25: splits in euro's en centen. 4 × €1,00 = €4,00. 4 × €0,25 = €1,00 (want 4 kwartjes = 1 euro). Totaal: €4,00 + €1,00 = €5,00.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Splits de vermenigvuldiging. Euro's: 4 × €1,00 = €4,00. Centen: 4 × €0,25 = €1,00 (want 4 kwartjes = 1 euro). Tel op: €4,00 + €1,00 = €5,00.",
        "solutionSteps": [
          "Splits: 4 × €1,25 = 4 × €1,00 + 4 × €0,25",
          "Euro's: 4 × €1,00 = €4,00",
          "Centen: 4 × €0,25 = €1,00 (4 kwartjes = 1 euro)",
          "Tel op: €4,00 + €1,00 = €5,00"
        ],
        "distractorExplanations": {
          "0": "Goed! 4 × €1,25 = €5,00. Vier kwartjes maken precies één euro.",
          "1": "Je dacht waarschijnlijk dat 4 × 25 cent = 125 cent = €1,25. Maar 4 × 25 = 100 cent = €1,00. Onthoud: 4 kwartjes = 1 euro, niet €1,25.",
          "2": "Je dacht waarschijnlijk dat je de centen kunt overslaan: 4 × €1 = €4. Maar je moet ook 4 × €0,25 = €1,00 bijtellen. Onthoud: reken altijd de centen mee.",
          "3": "Je dacht waarschijnlijk dat je maar 3 liter hoefde te rekenen: 3 × €1,25 = €3,75 ≈ €4,25. Maar de klant koopt 4 liter: 4 × €1,25 = €5,00. Onthoud: lees goed hoeveel stuks er gevraagd worden."
        }
      }
    },
    {
      "id": "GELD-KOMMA-007",
      "familyId": "GELD-KOMMA",
      "module": "Geld",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "geld_basis",
      "subSkill": "geld_kommagetallen",
      "questionType": "ordering",
      "question": "Een kassamedewerker moet deze bedragen op volgorde van klein naar groot leggen.",
      "options": ["€2,50", "€5,00", "€1,75", "€3,20"],
      "correctAnswer": 0,
      "data": {
        "ordering": {
          "items": ["€2,50", "€5,00", "€1,75", "€3,20"],
          "correctOrder": [2, 0, 3, 1]
        }
      },
      "conceptId": "money_ordering",
      "variantIndex": 7,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.70,
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0,
            "end": 6,
            "highlight": [1.75, 2.5, 3.2, 5],
            "label": "Bedragen op een getallenlijn: €1,75 — €2,50 — €3,20 — €5,00"
          }
        }
      ],
      "feedback": {
        "explanationText": "Vergelijk eerst de euro's, dan de centen. €1,75 heeft de minste euro's (1). Dan €2,50 (2 euro's) en €3,20 (3 euro's). €5,00 heeft de meeste euro's (5). Volgorde: €1,75 < €2,50 < €3,20 < €5,00.",
        "solutionSteps": [
          "Vergelijk de euro's: 1, 2, 3, 5",
          "Alle euro's zijn verschillend, dus de volgorde is duidelijk",
          "Van klein naar groot: €1,75 — €2,50 — €3,20 — €5,00"
        ]
      }
    }
  ]
}